import { ApplicationRef, ComponentRef, createComponent, Injectable, inject } from "@angular/core";
import { ToastComponent } from "@storeblocks/toast-ng";

export interface Toast {
  visible: boolean;
  options?: ToastOptions;
}

export interface ToastOptions {
  iconVariant?: "error" | "info" | "success" | "warning" | "neutral";
  duration?: "short" | "medium" | "long" | "always";
  title?: string;
  text?: string;
}

@Injectable({
  providedIn: "root",
})
export class ToastService {
  private readonly appRef = inject(ApplicationRef);

  private activeToast?: ComponentRef<ToastComponent>;

  public show(options?: ToastOptions): void {
    // Destroy any existing toast
    if (this.activeToast) {
      this.hide();
    }

    this.activeToast = createComponent(ToastComponent, {
      environmentInjector: this.appRef.injector,
    });

    this.activeToast.instance.rebrand = true;
    this.activeToast.instance.text = options?.text || "";
    this.activeToast.instance.title = options?.title || "";
    this.activeToast.instance.duration = options?.duration || "short";
    this.activeToast.instance.iconVariant = options?.iconVariant || "info";

    this.appRef.attachView(this.activeToast.hostView);
    const domElement = (this.activeToast.hostView as any).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElement);
  }

  public hide(): void {
    if (this.activeToast) {
      this.appRef.detachView(this.activeToast.hostView);
      // toast-ng's ngOnDestroy reads container.nativeElement while `visible` is true, but the container
      // only exists after the first render, so hiding a toast before that throws. We remove the toast
      // right away, so its fade-out (the only thing `visible` gates there) is not needed.
      this.activeToast.instance.visible = false;
      this.activeToast.destroy();
      this.activeToast = undefined;
    }
  }
}
